import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMenu } from '../contexts/MenuContext';
import { usePageMetaState } from '../hooks/usePageMeta';
import { resolveMenuByPath } from '../utils/menuResolve';

// Menüye bağlanamayan yardımcı sayfalarda (ör. /change-password) ve menü henüz
// yüklenmemişken sekmede marka adı durur.
const DEFAULT_TITLE = 'SalesOps';

/**
 * Tarayıcı sekmesinin başlığını AÇIK OLAN MENÜNÜN ADI yapar.
 *
 * Kaynak sırası menü → sayfa meta'sı: menü adı sabittir (Faturalar), sayfa meta'sı ise
 * detayda kayda özel olabilir (FT-2026-001). İstenen "menü adı" olduğu için menü kazanır;
 * menüsüz sayfalarda usePageMeta başlığına düşer.
 *
 * Çizim yapmaz — Layout içinde bir kez asılır, tüm ekranları tek noktadan kapsar
 * (bkz. FavoriteStar; aynı resolveMenuByPath eşlemesini kullanır).
 *
 * preferPageTitle: sıralamayı ters çevirir (sayfa meta'sı → menü). Embed modu (?embed=true,
 * sabit raporların ayrı pencerede açılan liste ekranı) bunu kullanır: o yolların kendi menü
 * kaydı yoktur, resolveMenuByPath önek eşleşmesiyle hepsini "Raporlar"a bağlar ve her rapor
 * penceresi aynı adı taşırdı. Sayfa meta'sı ise raporun kendi adını verir.
 */
export function DocumentTitle({ preferPageTitle = false }) {
  const location = useLocation();
  const { resolvedMenus, menuItems } = useMenu();
  const { title: pageTitle } = usePageMetaState();

  const menus = (resolvedMenus && resolvedMenus.length > 0) ? resolvedMenus : menuItems;
  const match = resolveMenuByPath(menus, location.pathname);
  const menuTitle = match ? (match.title ?? match.Title ?? '') : '';

  useEffect(() => {
    document.title = preferPageTitle
      ? (pageTitle || menuTitle || DEFAULT_TITLE)
      : (menuTitle || pageTitle || DEFAULT_TITLE);
  }, [menuTitle, pageTitle, preferPageTitle]);

  return null;
}
